import React from 'react'

import userProfileIcon from '../../../../assets/icons/user-profile.svg'

const BkFlowNavigationProfileMenuToggle = ({
	toggleMenuEvent,
	userFirstName,
	welcomeLabel,
}) => {

	return  (
		<button
			className="bk-flow-navigation__profile-menu-toggle"
			onClick={() => toggleMenuEvent()}
		>
			<img
				src={userProfileIcon}
				alt="Profile Login Avatar"
			/>
			<span>{ `${welcomeLabel} ${userFirstName}` }</span>
		</button>
	)
}

BkFlowNavigationProfileMenuToggle.defaultProps = {
	userFirstName: 'User',
	welcomeLabel: 'Welcome'
}

export default BkFlowNavigationProfileMenuToggle


// WEBPACK FOOTER //
// ./src/components/structure/navigation/profile/BkFlowNavigationProfileMenuToggle.js